<template>
    <select  
            v-model="valueModel"
            class="form-control"
    >
        <template v-for="group in optionGroups">
            <optgroup v-bind:label="group.path" v-if="group.path" :key="group.path">
                <option
                        v-for="division in group.divisions"
                        v-bind:value="division.id"
                        v-bind:key="division.id"
                        v-bind:selected="valueModel === division.id"
                        v-bind:disabled="!division.isEnabled"
                >
                    {{ division.name }}
                </option>
            </optgroup>


            <option
                    v-else
                    v-for="division in group.divisions"
                    v-bind:value="division.id"
                    v-bind:key="division.id"
                    v-bind:selected="valueModel === division.id"
                    v-bind:disabled="!division.isEnabled"
            >
                {{ division.name }}
            </option>
        </template>
    </select>
</template>

<script>
    import guidMixin from '../../Util/Mixins/guid';
    
    import _ from 'lodash'

    export default {
        name: "division-dropdown",
        mixins: [guidMixin],
        created(){
            const vm = this;
            
            //Either take the provided divisionId, or the first divisionId from the first optionGroup
            vm.valueModel = vm.value || vm.optionGroups[0].divisions[0].id;
        },
        methods: {
            sortDivisionList(divisionList){
                const vm = this;
                
                //Sort self + children
                divisionList.childDivisions = _.sortBy(divisionList.childDivisions, 'name');
                divisionList.childDivisions.forEach(vm.sortDivisionList);
            },
            buildOptionGroup(division, parentDivisionNames){
                const path = parentDivisionNames.join(' → ');
                
                const childDivisionOptionGroups = division.childDivisions.map(d => ({
                    id: d.id,
                    name: d.name,
                    isEnabled: d.isEnabled
                }));
                
                return {
                    path: path,
                    divisions: childDivisionOptionGroups
                }
            }
        },
        computed: {
            optionGroups(){
                //Vue needs a flat list for rendering
                
                const vm = this;
                const optionGroups = [];

                const pushOptionGroupsImpl = (divisionList, parentDivisionNames) => {
                    //Skip any divisions without children
                    if(!divisionList.childDivisions.length)
                    {
                        return;
                    }
                    
                    //Ensure our division is last in the parent names collection
                    parentDivisionNames.push(divisionList.name);

                    optionGroups.push(vm.buildOptionGroup(divisionList, parentDivisionNames));
                    
                    //Recursively process our children
                    divisionList.childDivisions.forEach(child => {
                        pushOptionGroupsImpl(child, parentDivisionNames);
                    });

                    //Remove our child division name from the list
                    parentDivisionNames.pop();
                };

                //Start with our root
                if(!vm.excludeOwnDivision){
                    optionGroups.push(vm.buildOptionGroup({
                        id: vm.internalDivisionList.id,
                        name: vm.internalDivisionList.name,
                        childDivisions: [vm.internalDivisionList]
                    }, []));   
                }
                
                //Then process all children in order
                pushOptionGroupsImpl(vm.internalDivisionList, []);
                return optionGroups;
            },
            internalDivisionList(){
                const vm = this;
                const divisions = vm.divisions;
                
                //Prefer directly using divisionList over divisions collection
                if(vm.divisionList && vm.divisionList.id){
                    return vm.divisionList;
                }
                
                //In case of no divisionList prop being used; fallback to our old implementation and convert our divisions collections
                if(divisions.length === 0){
                    return {};
                }

                //Create a lookup of divisionId -> division as to not traverse the array every single time 
                //we're searching for a specific division 
                const divisionLookup = divisions.reduce((lookup, division) => {
                    lookup[division.Id] = division;
                    return lookup;
                }, {});

                const divisionsListLookup = divisions.reduce((divisionListObj, division) => {
                    let listItem = divisionListObj[division.Id];
                    let parentListItem = divisionListObj[division.ParentId];

                    //Only create a new item if it was not created beforehand due to being another already processed divisions parent
                    if(!listItem){
                        listItem = divisionListObj[division.Id] = {
                            childDivisions: []
                        };
                    }

                    listItem.id = division.Id;
                    listItem.name = division.Name;
                    listItem.isEnabled = division.IsEnabled;

                    //A division without a parent should be a root division, and thus can't have a parent item
                    if(!parentListItem && divisionLookup[division.ParentId]){
                        parentListItem = divisionListObj[division.ParentId] = {
                            childDivisions: []
                        };
                    }
                    
                    if(parentListItem){
                        parentListItem.childDivisions.push(listItem);
                    }
                    
                    return divisionListObj;
                });
                
                //Take the first division without a parent
                const rootDivisionId = divisions.find(d => !divisionLookup[d.ParentId]).Id;
                const rootItem = divisionsListLookup[rootDivisionId];
                
                //Our list is not pre-sorted, thus we need to do it ourselves
                vm.sortDivisionList(rootItem);
                
                return rootItem;
            }
        },
        watch: {
            valueModel(newValue, oldValue){
                //No need to do anything when the value hasn't actually changed
                if(newValue === oldValue){
                    return;
                }
                
                const vm = this;
                
                //Emit an input event each time our value changes
                vm.$emit('input', newValue);
            }
        },
        data: () => ({
            valueModel: ''
        }),
        props: {
            //Legacy property as to not break existing code
            divisions: {
                type: Array,

                // Id: '',
                // Name: '',
                // ParentId: '',
                // IsEnabled: true
                default: () => ([])
            },
            divisionList: {
                type: Object,

                //id: '',
                //name: '',
                //isEnabled: true,
                //childDivisions: []
                default: () => ({})
            },
            value: {
                type: String
            },
            excludeOwnDivision: {
                type: Boolean,
                required: false
            }
        }
    }
</script>
